import type {
	Action,
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
} from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

type State = {
	isOpen: boolean;
	openFrom: string;
};

const initialState: State = {
	isOpen: false,
	openFrom: '',
};

const actions = {
	setIsOpen:
		(isOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({
				isOpen,
			});
		},
	setOpenFrom:
		(openFrom: string): Action<State> =>
		({ setState }) => {
			setState({ openFrom });
		},
};

const Store = createStore({
	initialState,
	actions,
	name: 'UniversalCreateStore',
});

export const useUniversalCreateState: HookStateFunction<State, void> = createStateHook(Store);
export const useUniversalCreateActions: HookActionsFunction<
	BoundActions<
		State,
		{
			setIsOpen: (isOpen: boolean) => Action<State>;
			setOpenFrom: (openFrom: string) => Action<State>;
		}
	>
> = createActionsHook(Store);
